__turbopack_context__.v({
  "className": "barlow_f329092c-module__hJxyta__className",
});
